module.exports = __webpack_public_path__ + "images/logo-black@2x_edfd419672b925a8718ae81ae5c3edc5.png";